import config from '@/config/index';
import { useOrderQuery } from '@/hooks/queries/use-order-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader } from '../ui/loader';

export default function ButtonGroup() {
  const navigate = useNavigate();
  const { orderId, code } = useParams();
  const { data: order, isLoading, error } = useOrderQuery(orderId!);

  if (error) throw error;

  if (isLoading) return <Loader />;

  if (!order) return null;

  return (
    <div className="flex items-center space-x-4">
      <button
        disabled={!order}
        onClick={() => {
          navigate(`/${code}/products`);
        }}
        className="text-white bg-violet-700 hover:bg-violet-800 focus:ring-4 focus:ring-violet-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-violet-600 dark:hover:bg-violet-700 focus:outline-none dark:focus:ring-violet-800"
      >
        Fortsätt handla
      </button>
      <a
        href={config.links.landing}
        className="py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-violet-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
      >
        Vad är Piggo?
      </a>
    </div>
  );
}
